<section class="home-team-cards-w">
  <h2>{{ 'home-page.team-headline' |  translate}}</h2>

  <div class="home-team-cards-w_team-w">
    <div class="home-team-cards-w_team-w_left-section">
      <h3>{{ 'home-page.team-subheadline' |  translate}}</h3>
      <p>{{'home-page.team-text' | translate}}</p>

      <div class="home-team-cards-w_team-w_left-section_btn-w">
        <app-button
          [label]="'home-page.team-btn' | translate"
          [href]="'/about-us#team-section'"
        />
      </div>
    </div>

    <div class="home-team-cards-w_team-w_right-section">
      <img src="../../../../assets/images/home-page/team-img.png" alt="team image"/>
    </div>
  </div>

  <div class="home-team-cards-w_img-txt-w">
    <app-image-text-card-wrapper
      [learnMoreHref]="'/about-us#team-section'"
      [headline]="'home-page.sectors-headline' | translate"
      [learnMore]="'home-page.hps-learn-more' | translate"
      [services]="services"
      [applyShadow]="false"
      [enableCarouselIndicators]="true"
    />
  </div>
</section>
